import React, { useEffect, useMemo, useState } from 'react';
import { format, startOfMonth } from 'date-fns';
import { Controller } from 'react-hook-form';
import { Col, Input, Row } from 'reactstrap';
import Datepicker from 'components/Inputs/DatePicker';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';
import { useListOpportunityStagesByRecordType } from 'views/CRM/OpportunityStages/hooks/useListOpportunityStagesByRecordType';
import FlexSelect from 'components/Inputs/FlexSelect';
import { custom_select } from '../../../../../../../../assets/styles/multiple_select';
import Select from 'react-select/async';
import SelectContact from 'react-select/creatable';
import ClientService from '../../../../../../../../views/Clients/service/index';
import { useSearchAccounts } from '../../../../../hooks/useSearchAccounts';
import { toast } from 'react-toastify';
import { opportunityTypes } from 'views/CRM/shared/utils/opportunityTypes';
import { useGetLostReasonByEntity } from 'views/CRM/hooks/useGetLostReasonByEntity';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';

const dateRules = {
  required: 'Data é obrigatória',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};
const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(
    date.getFullYear('pt-br'),
    date.getMonth('pt-br'),
    1
  );
  return format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
};
const toISOFormat = (dateTimeString) => {
  const [date] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');
  return `${DD}/${MM}/${YYYY}`;
};

const temperatureOptions = [
  { label: 'Quente', value: 10 },
  { label: 'Morno', value: 5 },
  { label: 'Frio', value: 1 }
];

const DefaultFieldsFilterForm = ({
  control,
  setValue,
  getValues,
  recordTypeId,
  register,
  memorizeFilters,
  getMemorizedFilters,
  loadingClean,
  setLoadingClean
}) => {
  const { userList } = useUsers();
  const {
    opportunityStages,
    getOpportunityStagesByRecordType,
    isLoadingOpportunityStages
  } = useListOpportunityStagesByRecordType();
  const { listLostReason } = useGetLostReasonByEntity({
    entity: entitiesName.OPPORTUNITY,
    recordTypeId
  });
  const showAllOpportunities = useMemo(() => {
    const flag = localStorage.getItem('show_all_opportunities');
    return flag === 'true';
  }, []);
  const [clientToSelect, setClientsToSelect] = useState([]);
  const [filterListLostReason, setFilterListLostReason] = useState([]);
  const { isSearching, filterAccounts } = useSearchAccounts();
  const [timeoutID, setTimeoutID] = useState(null);
  const [account, setAccount] = useState();
  const [contact, setContact] = useState();

  const seachClientSelect = (value) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    setTimeoutID(
      setTimeout(() => {
        handleGetClient(value);
      }, 1200)
    );
  };

  const handleGetClient = (value) => {
    if (value) {
      ClientService.getAllFilter('cliente', '', 'ALL', {
        nome: value,
        email: value
      })
        .then((response) => {
          const { content } = response.data;
          const sortClientsArray = sortData(content);
          const setData = sortClientsArray.map((client) => {
            return {
              email: client.email,
              telefone: client.telefone,
              label: client.nome,
              value: client.id
            };
          });
          setClientsToSelect(setData);
        })
        .catch((err) => {
          const message =
            (err.response && err.response.data) || 'Erro ao carregar contatos';
          toast.error(message, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      setClientsToSelect();
    }
  };

  const sortData = (data) => {
    return data.sort((a, b) => {
      const keyA = a.name || a.nome;
      const keyB = b.name || b.nome;
      return keyA.toLowerCase().localeCompare(keyB.toLowerCase());
    });
  };

  useEffect(() => {
    if (!listLostReason) return;

    const options = listLostReason[0]?.options || [];
    const formattedOptions = options
      .filter((option) => option.recordTypeIds.includes(Number(recordTypeId)))
      .map((option) => ({ label: option.value, value: option.value }));

    setFilterListLostReason(formattedOptions);
  }, [listLostReason]);

  useEffect(() => {
    getOpportunityStagesByRecordType(recordTypeId);
  }, [getOpportunityStagesByRecordType, recordTypeId]);

  useEffect(() => {
    setLoadingClean(false);
    const filters =
      JSON.parse(localStorage.getItem('crm-list-filters-opportunity')) || {};
    const { accountId, accountName, contactId, contactName } = filters;

    if (accountName) {
      setAccount({
        label: accountName || null,
        value: accountId || null
      });
    } else {
      setAccount(null);
    }

    if (contactName) {
      setContact({
        label: contactName || null,
        value: contactId || null
      });
    } else {
      setContact(null);
    }
  }, [recordTypeId, loadingClean]);

  return (
    <>
      <Row className="mb-3">
        <Col sm="8">
          <label className="form-control-label">Buscar</label>
          <Controller
            as={
              <Input
                type="text"
                name="textQuery"
                placeholder="Buscar por título da oportunidade, nome da conta ou nome do contato"
              />
            }
            control={control}
            name="textQuery"
            defaultValue=""
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Fase da Oportunidade</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={opportunityStages || []}
                isMulti={true}
                value={props.value}
                valueController={setValue}
                fieldName="stageId"
                labelName="name"
                valueName="id"
                isClearable={true}
                disabled={isLoadingOpportunityStages}
                closeMenuOnSelect={false}
              />
            )}
            control={control}
            name="stageId"
            defaultValue=""
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={showAllOpportunities ? '4' : '6'}>
          <label className="form-control-label">Data inicial</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateBegin"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateBegin"
            rules={dateRules}
            defaultValue={getDateBegin()}
          />
        </Col>
        <Col sm={showAllOpportunities ? '4' : '6'}>
          <label className="form-control-label">Data final</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateEnd"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateEnd"
            defaultValue={new Date().toLocaleDateString('pt-br')}
            rules={{
              ...dateRules,
              validate: async (value) => {
                if (
                  new Date(toISOFormat(value)) <
                  new Date(toISOFormat(getValues()['dateBegin']))
                ) {
                  return 'A data final não pode ser anterior à inicial!';
                } else {
                  return true;
                }
              }
            }}
          />
        </Col>
        {showAllOpportunities && (
          <Col sm="4">
            <label className="form-control-label">Responsável</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={userList || []}
                  isMulti={true}
                  value={props.value}
                  valueController={setValue}
                  fieldName="responsibleLogin"
                  labelName="name"
                  valueName="login"
                  isClearable={true}
                  closeMenuOnSelect={false}
                />
              )}
              control={control}
              name="responsibleLogin"
              defaultValue=""
            />
          </Col>
        )}
      </Row>
      <Row className="mb-3">
        <Col sm="4">
          <label className="form-control-label">Conta</label>
          <Controller
            render={() => (
              <Select
                styles={custom_select}
                placeholder="Busca rápida"
                isClearable={true}
                name="accountId"
                fieldName="accountId"
                valueController={setValue}
                isLoading={isSearching}
                loadingMessage={() => 'Buscando...'}
                noOptionsMessage={({ inputValue }) =>
                  !inputValue
                    ? 'Digite para pesquisar'
                    : 'Nenhum resultado encontrado'
                }
                loadOptions={async (inputValue) => {
                  const res = await filterAccounts(inputValue);
                  return (
                    res &&
                    res.map((account) => ({
                      label: account.name,
                      value: account.id
                    }))
                  );
                }}
                onChange={(data) => {
                  if (data) {
                    const { value, label } = data;
                    setAccount({
                      label,
                      value
                    });
                    setValue('accountId', value);
                    memorizeFilters({
                      ...getMemorizedFilters(),
                      accountId: value,
                      accountName: label
                    });
                  } else {
                    setAccount(null);
                    setValue('accountId', null);
                  }
                }}
                value={
                  account
                    ? {
                        label: account.label,
                        value: account.id
                      }
                    : ''
                }
                defaultValue={
                  account
                    ? {
                        label: account.label,
                        value: account.id
                      }
                    : ''
                }
              />
            )}
            control={control}
            name="accountId"
            defaultValue=""
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label text-capitalize">Contato</label>
          <Controller
            render={() => (
              <SelectContact
                isClearable
                allowCreateWhileLoading={false}
                isValidNewOption={() => false}
                name="contactId"
                fieldName="contactId"
                valueController={setValue}
                placeholder="Busca rápida"
                styles={custom_select}
                options={clientToSelect}
                onInputChange={seachClientSelect}
                onChange={(data) => {
                  if (data) {
                    const { value, label } = data;
                    setContact({
                      label,
                      value
                    });
                    setValue('contactId', value);
                    memorizeFilters({
                      ...getMemorizedFilters(),
                      contactId: value,
                      contactName: label
                    });
                  } else {
                    setContact(null);
                    setValue('contactId', null);
                  }
                }}
                value={
                  contact
                    ? {
                        label: contact.label,
                        value: contact.id
                      }
                    : ''
                }
                defaultValue={
                  contact
                    ? {
                        label: contact.label,
                        value: contact.id
                      }
                    : ''
                }
              />
            )}
            control={control}
            name="contactId"
            defaultValue=""
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Tipo de Oportunidade</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={opportunityTypes || []}
                isMulti={true}
                value={props.value || []}
                valueController={setValue}
                fieldName="type"
                labelName="name"
                valueName="value"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            defaultValue={null}
            name="type"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="4">
          <label className="form-control-label">Motivo de perda</label>
          <Controller
            render={(props) => (
              <FlexSelect
                isClearable={true}
                placeholder="Selecione o motivo"
                dataOptions={filterListLostReason || []}
                isMulti={true}
                closeMenuOnSelect={true}
                value={props.value || []}
                valueController={setValue}
                fieldName="lostReason"
                labelName="value"
                valueName="value"
              />
            )}
            control={control}
            name="lostReason"
            defaultValue={null}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Temperatura</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={temperatureOptions || []}
                isMulti={true}
                value={props.value}
                valueController={setValue}
                fieldName="temperature"
                labelName="label"
                valueName="value"
                isClearable={true}
                closeMenuOnSelect={false}
              />
            )}
            control={control}
            name="temperature"
            defaultValue=""
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Canal de origem</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={[
                  { name: 'WhatsApp', value: 'whatsapp' },
                  { name: 'Email', value: 'email' },
                  { name: 'Chat', value: 'chat' },
                  { name: 'Telefone', value: 'telefone' },
                  { name: 'Webchat', value: 'webchat' }
                ]}
                isMulti={false}
                value={props.value}
                valueController={setValue}
                fieldName="channelOrigin"
                labelName="name"
                valueName="value"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            defaultValue={null}
            name="channelOrigin"
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Gerada via Lead</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={[
                  { name: 'Sim', value: true },
                  { name: 'Não', value: false }
                ]}
                isMulti={false}
                value={props.value}
                valueController={setValue}
                fieldName="generatedByLead"
                labelName="name"
                valueName="value"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            defaultValue={null}
            name="generatedByLead"
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Gerada Manualmente</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={[
                  { name: 'Sim', value: true },
                  { name: 'Não', value: false }
                ]}
                isMulti={false}
                value={props.value}
                valueController={setValue}
                fieldName="isManual"
                labelName="name"
                valueName="value"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            defaultValue={null}
            name="isManual"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="12">
          <label
            className="form-control-label"
            style={{ marginRight: '20px', fontWeight: '400' }}
          >
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="creation"
              defaultChecked={true}
            />{' '}
            Data de criação
          </label>
          <label className="form-control-label" style={{ fontWeight: '400' }}>
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="last_update"
              defaultChecked={false}
            />{' '}
            Data de última alteração
          </label>
          <label
            className="form-control-label"
            style={{ fontWeight: '400', marginLeft: '20px' }}
          >
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="closed"
              defaultChecked={false}
            />
            Data de fechamento
          </label>
        </Col>
      </Row>
    </>
  );
};

export default DefaultFieldsFilterForm;
